import React from 'react';
import { Link } from 'react-router-dom';
import { features } from '../lib/data';
import { iconMap, IconName } from './Icons';

export const Features: React.FC = () => {
  return (
    <div id="features" className="mx-auto max-w-7xl px-6 py-24 sm:py-32 lg:px-8">
      <div className="mx-auto max-w-2xl lg:text-center">
        <h2 className="text-base/7 font-semibold" style={{ color: '#00D084' }}>Everything after the sale</h2>
        <p className="mt-2 text-4xl font-semibold tracking-tight text-pretty sm:text-5xl lg:text-balance" style={{ color: '#241E61' }}>
          One platform for every post-purchase moment
        </p>
        <p className="mt-6 text-lg/8 text-gray-600">
          Connect with customers from the moment they open the box. Registration, support, warranty, spares, compliance — all browser-based, no app required.
        </p>
      </div>
      <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-none">
        <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-10 lg:max-w-none lg:grid-cols-3 xl:grid-cols-4 lg:gap-y-16">
          {features.map((feature) => {
            const IconComponent = iconMap[feature.icon as IconName];
            return (
              <Link
                key={feature.name}
                to={`/product/${feature.slug}`}
                className="group relative pl-16 block hover:opacity-80 transition-opacity"
              >
                <dt className="text-base/7 font-semibold" style={{ color: '#241E61' }}>
                  <div className="absolute top-0 left-0 flex size-10 items-center justify-center rounded-lg" style={{ backgroundColor: '#241E61' }}>
                    <IconComponent className="h-6 w-6 text-white" />
                  </div>
                  {feature.name}
                  <span className="ml-1 text-xs opacity-0 group-hover:opacity-100 transition-opacity" style={{ color: '#00D084' }}>&rarr;</span>
                </dt>
                <dd className="mt-2 text-base/7 text-gray-600">{feature.description}</dd>
              </Link>
            );
          })}
        </dl>
      </div>
    </div>
  );
};
